export default __webpack_public_path__ + "static/media/logo-ic-larget.8bf32d98.svg";